import PageLayout from '@/components/PageLayout';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import ProductSupport from '@/components/ProductCommon/ProductSupport';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';
import { useSupportData } from '@/utils/hooks';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import SP220wDouble from '@elem/compPage/SP220wDouble';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

// 产品详情页参数
const productName = 'new-220w-bifacial-solar-panel';
const generalKey = 'product_sp_220w_bifacial_solar_panel';

const whiteLocaleList = ['us', 'jp', 'br', 'mx', 'kr', 'ph'];

export default function Page({ SEO }: any) {
    const { gloproductlist, useLang } = useGlobal();
    const [theme, setTheme] = useState('');
    const router = useRouter();
    const { locale = 'us' } = router;
    const { t } = useLang('solar_panel_220w_double');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    // // 如果不存在该页面,返回404
    // if (!productMsg.generalKey && gloproductlist.length && typeof window !== 'undefined') {
    //     return router.push(`${location.origin}/${router.locale}/404`);
    // }
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);

    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
    };

    useEffect(() => {
        if (!whiteLocaleList.includes(locale)) {
            router.push(`/${locale}/404`);
        }
    }, []);

    return (
        <>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA list={whiteLocaleList} locale={locale} pathname={productMsg.url} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={t('A_title')}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                />
                <div className="product-tab product-tab-Overview show-tab">
                    <SP220wDouble />
                </div>
                <div className="product-tab product-tab-Specs">
                    <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className="product-tab product-tab-Support">
                    <ProductSupport theme={theme} supportData={supportData}></ProductSupport>
                </div>
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: any) {
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
